import { SaveFormat } from "expo-image-manipulator";

import { toMs } from "@/utils/date.util";

const SmtWelcomeModalDelayMs = toMs({ seconds: 2 });

enum SMTEntryType {
  Meal = "meal",
}

enum SMTModalSubDeepLinks {
  Add = "add",
  Entry = "entry",
}

const SMTFallbackUIConfig: SMTUIConfig = {
  addFood: {
    addPhoto: {
      buttons: {
        noPhoto: "Continue without photo",
        selectPhoto: "Choose from library",
        takePhoto: "Take a photo",
      },
      description: "To start, please add a photo of your meal",
      title: "Add food",
    },
    entryForm: {
      buttons: {
        addPhoto: "Add photo",
        replaceImage: "Replace image",
        saveEntry: "Save entry",
      },
      description: "Please fill out the form below to add your entry.",
      placeholderText: {
        comment:
          "Please share any other thoughts, feelings, behaviors, or comments",
        description: "Please describe the food you’d like to add",
      },
      title: "Add food",
    },
    selectPatient: {
      description: "Which patient would you like to add an entry for?",
      title: "Please choose a patient",
    },
  },
};

const SMTPermissionTypeValue = {
  Add: "ADD",
  NoAccess: "NO_ACCESS",
  View: "VIEW",
} satisfies Record<string, SMTPermissionType>;

const SMTFoodTypeValue = {
  Meal: "MEAL",
  Snack: "SNACK",
} satisfies Record<string, SMTFoodType>;

enum SMTWeekLogLayout {
  DayCircleSize = 36,
  NumberOfDays = 7,
}

const SMTImageCompressionOption = {
  // Observed a good balance between image quality and size at 0.2 compression rate for JPEG
  // A lower compression rate ( c > 0.2 ) results in significantly larger image sizes with minimal quality improvement
  CompressionRate: 0.2,
  // Do not use WEBP until https://teamequip.atlassian.net/browse/JN-1991 is resolved
  Format: SaveFormat.JPEG,
};

export {
  SMTEntryType,
  SMTFallbackUIConfig,
  SMTFoodTypeValue,
  SMTImageCompressionOption,
  SMTModalSubDeepLinks,
  SMTPermissionTypeValue,
  SMTWeekLogLayout,
  SmtWelcomeModalDelayMs,
};
